import { render, staticRenderFns } from "./BaseModalSmall.vue?vue&type=template&id=1e08d1f6&scoped=true"
import script from "./BaseModalSmall.vue?vue&type=script&lang=js"
export * from "./BaseModalSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e08d1f6",
  null
  
)

export default component.exports